var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 1.16789C14.0976 1.55842 14.0976 2.19158 13.7071 2.58211L5.45711 10.8321C5.06658 11.2226 4.43342 11.2226 4.04289 10.8321L0.292893 7.08211C-0.0976311 6.69158 -0.0976311 6.05842 0.292893 5.66789C0.683417 5.27737 1.31658 5.27737 1.70711 5.66789L4.75 8.71079L12.2929 1.16789C12.6834 0.777369 13.3166 0.777369 13.7071 1.16789Z",
    fill: "#008018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.fb6d18b66a31d9a0ca870b1e863676e1.svg";
export { ForwardRef as ReactComponent };